import React from 'react'
import PropTypes from 'prop-types'
import {useDisclosure} from '@chakra-ui/react'
import SupplierRewardsProgramLearnMoreModal from '../components/SupplierRewardsProgramLearnMoreModal'

const SupplierRewardsProgramLearnMoreModalContext = React.createContext()

function useSupplierRewardsProgramLearnMoreModal() {
  const context = React.useContext(SupplierRewardsProgramLearnMoreModalContext)

  if (!context) {
    throw new Error(
      'useSupplierRewardsProgramLearnMoreModal must be used within a SupplierRewardsProgramLearnMoreModalProvider',
    )
  }

  return context
}

function SupplierRewardsProgramLearnMoreModalProvider({children, size}) {
  const {isOpen, onOpen, onClose} = useDisclosure()

  const value = React.useMemo(
    () => ({
      isOpen,
      onOpen,
      onClose,
    }),
    [isOpen, onClose, onOpen],
  )

  return (
    <SupplierRewardsProgramLearnMoreModalContext.Provider value={value}>
      {children}
      <SupplierRewardsProgramLearnMoreModal {...value} size={size} />
    </SupplierRewardsProgramLearnMoreModalContext.Provider>
  )
}

SupplierRewardsProgramLearnMoreModalProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    'full',
  ]),
}

SupplierRewardsProgramLearnMoreModalProvider.defaultProps = {
  size: '6xl',
}

export {
  SupplierRewardsProgramLearnMoreModalProvider,
  useSupplierRewardsProgramLearnMoreModal,
}
